import { useEffect } from 'react';

/**
 * Sets the browser tab title for a page. Restores the default on unmount.
 * Use this for authenticated dashboard pages where full Helmet SEO meta
 * isn't needed — it's lighter than adding a full <Helmet> block.
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = 'BookMyCoaching';
    };
  }, [title]);
}
